import { createFileRoute, useRouter } from '@tanstack/react-router';
import { useCallback } from 'react';
import { z } from 'zod';

import { LoginPage } from '@/features/auth/LoginPage';

const searchSchema = z.object({
  /**
   * Dokąd wrócić po zalogowaniu. Tylko ścieżki wewnętrzne — „//host” byłoby
   * otwartym przekierowaniem na obcą domenę.
   */
  returnTo: z
    .string()
    .refine((value) => value.startsWith('/') && !value.startsWith('//'), {
      message: 'Dozwolone są wyłącznie ścieżki wewnętrzne.',
    })
    .catch('/'),
});

export const Route = createFileRoute('/logowanie')({
  validateSearch: searchSchema,
  component: LoginRoute,
});

function LoginRoute() {
  const { returnTo } = Route.useSearch();
  const router = useRouter();

  // history.replace zamiast navigate({ to }) — returnTo jest zwykłym stringiem
  // z adresu, a nie jedną ze znanych routerowi tras.
  const goBack = useCallback(() => {
    router.history.replace(returnTo);
  }, [router, returnTo]);

  return <LoginPage onAuthenticated={goBack} />;
}
